import { AuthCognitoIdentityServiceProvider, UserAttributes } from './aws.cognito'

export interface CognitoUserProvider {
  updateAttributes (username: string, attributes: UserAttributes): Promise<void>
  activate (username: string, crcId:string): Promise<void>
  deactivate (username: string): Promise<void>
  getUser (username: string): Promise<AWS.CognitoIdentityServiceProvider.AdminGetUserResponse>
  getEmail (username: string): Promise<string|undefined>
}

export default class ManageCognitoUserProvider implements CognitoUserProvider {
  static readonly USER_ACTIVATE_ATTRIBUTE_NAME = 'custom:activatedAt'
  static readonly USER_AFFILIATION_ATTRIBUTE_NAME = 'custom:affiliation'
  static readonly ASSGINMENT_ATTRIBUTE_NAME = 'custom:assignment'

  userPoolId: string
  provider: AuthCognitoIdentityServiceProvider

  constructor (userPoolId: string) {
    this.provider = new AuthCognitoIdentityServiceProvider()
    this.userPoolId = userPoolId
  }

  async updateAttributes (username: string, attributes: UserAttributes) {
    try {
      await this.provider.adminUpdateUserAttributes({
        UserPoolId: this.userPoolId,
        Username: username,
        UserAttributes: attributes
      })
    } catch (error) {
      throw error
    }
  }

  async changeCrcId (username: string, crcId: string) {
    try {
      await this.updateAttributes(
        username,
        [
          {
            Name: ManageCognitoUserProvider.USER_AFFILIATION_ATTRIBUTE_NAME,
            Value: crcId
          }
        ])
      console.log(`change user ${username}, crcId ${crcId}`)
    } catch (error) {
      throw error
    }
  }

  async activate (username: string, crcId: string) {
    try {
      await this.updateAttributes(
        username,
        [
          {
            Name: ManageCognitoUserProvider.USER_ACTIVATE_ATTRIBUTE_NAME,
            Value: (new Date()).toISOString()
          },
          {
            Name: ManageCognitoUserProvider.USER_AFFILIATION_ATTRIBUTE_NAME,
            Value: crcId
          }
        ])
      console.log(`activated user ${username}`)
    } catch (error) {
      throw error
    }
  }

  async deactivate (username: string) {
    try {
      await this.updateAttributes(
        username,
        [
          {
            Name: ManageCognitoUserProvider.USER_ACTIVATE_ATTRIBUTE_NAME,
            Value: ''
          },
          {
            Name: ManageCognitoUserProvider.USER_AFFILIATION_ATTRIBUTE_NAME,
            Value: ''
          }
        ])
      console.log(`deactivated user ${username}`)
    } catch (error) {
      throw error
    }
  }

  async getUser (username: string): Promise<AWS.CognitoIdentityServiceProvider.AdminGetUserResponse> {
    try {
      return await this.provider.adminGetUser({
        UserPoolId: this.userPoolId,
        Username: username
      })
    } catch (error) {
      throw error
    }
  }

  async getEmail (username: string): Promise<string | undefined> {
    try {
      const cognitoUser = await this.getUser(username)
      return this.getAttributeByCognitoUser(cognitoUser, 'email')
    } catch (error) {
      throw error
    }
  }

  getAttributeByCognitoUser (cognitoUser:AWS.CognitoIdentityServiceProvider.AdminGetUserResponse, attributeName:string): string | undefined {
    try {
      if (cognitoUser.UserAttributes) {
        const attribute = cognitoUser.UserAttributes.find((userAttribute) => userAttribute.Name === attributeName)
        if (attribute) {
          return attribute.Value
        }
      }
      return undefined
    } catch (error) {
      throw error
    }
  }
}
